// Exports

import getCookieOrMeta from '../storage/getCookieOrMeta';

export function extractCampaign(params) {
  if (params.campaignid) return params.campaignid;
  if (params.capaignid) return params.capaignid;
  return params.campaign_id;
}

export function extractNetwork(params) {
  if (params.network) return params.network;
  if (String(params.networkbing) === '1') return 'bing';
}

export function getQueryParam(paramName) {
  const param = Object.entries(urlParams()).find(([k, _]) => k === paramName);

  return param !== undefined ? param[1] : '';
}

export function trackableParams(args) {
  const tracking = (window.components || {}).tracking || {};
  const params = { ...urlParams(), ...tracking, ...args };
  params.param_string = location.search;
  params.path = location.pathname;
  params.network = extractNetwork(params);
  params.campaign_id = extractCampaign(params);
  if (getCookieOrMeta('visitor-id')) params.visitor_id = getCookieOrMeta('visitor-id');
  params.referer = document.referrer;
  return params;
}

export function urlParams() {
  if (!window.location.search) return {};

  // try/catch in case window.locatin.search contains something odd
  try {
    return JSON.parse('{"' + decodeURI(window.location.search
      .replace(/^\?/, '')
      .replace(/^&/, '')
      .replace(/&$/, '')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')) + '"}');
  } catch (SyntaxError) {
    console.warn('Invalid query string for tracking');
  }

  return {};
}
